<template>
  <header class="header-bar">
    <h2>{{ fullTitle }}</h2>
    
    <div class="header-actions">
      <el-button v-if="!isLogin" @click="$emit('showLogin')">登录</el-button>
      <template v-else>
        <el-dropdown v-if="userInfo && userInfo.role === 2">
          <el-button type="primary">
            操作菜单 <el-icon class="el-icon--right"><arrow-down /></el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="goToTaskList">任务列表</el-dropdown-item>
              <el-dropdown-item @click="goToUserList">查看学生列表</el-dropdown-item>
              <el-dropdown-item @click="goToAttendance">点名</el-dropdown-item>
              <el-dropdown-item @click="handleShowAddTask">添加任务</el-dropdown-item>
              <el-dropdown-item @click="handleShowAddStudent">添加学生</el-dropdown-item>
              <el-dropdown-item @click="handleShowSettings">设置</el-dropdown-item>
              <el-dropdown-item @click="goToSeatMap">座位表</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dropdown v-if="userInfo">
          <span class="el-dropdown-link">
            {{ userInfo.username }}<el-icon class="el-icon--right"><arrow-down /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </template>
    </div>

    <!-- 添加任务弹窗 -->
    <el-dialog
      title="添加任务"
      v-model="showAddTaskDialog"
      width="500px"
      :close-on-click-modal="false"
      :fullscreen="isMobile"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="addRules"
        label-width="80px"
      >
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="addForm.description"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
        <el-form-item label="标签" prop="labels">
          <el-input v-model="addForm.labels" placeholder="多个标签用逗号分隔" />
        </el-form-item>
        <el-form-item label="部分" prop="part">
          <el-input v-model="addForm.part" placeholder="例如：day01" />
        </el-form-item>
        <el-form-item label="序号" prop="orderNum">
          <el-input-number v-model="addForm.orderNum" :min="1" :max="999" />
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="addForm.type" placeholder="例如：河南大学" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showAddTaskDialog = false">取消</el-button>
          <el-button type="primary" @click="submitAddTask" :loading="isAdding">
            保存
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 添加学生弹窗 -->
    <el-dialog
      title="添加学生"
      v-model="showAddStudentDialog"
      width="400px"
      :close-on-click-modal="false"
      :fullscreen="isMobile"
    >
      <el-form
        ref="addStudentFormRef"
        :model="addStudentForm"
        :rules="addStudentRules"
        label-width="80px"
      >
        <el-form-item label="学号" prop="studentId">
          <el-input v-model="addStudentForm.studentId" placeholder="请输入学号" />
        </el-form-item>
        <el-form-item label="姓名" prop="username">
          <el-input v-model="addStudentForm.username" placeholder="请输入姓名" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showAddStudentDialog = false">取消</el-button>
          <el-button type="primary" @click="submitAddStudent" :loading="isAddingStudent">
            保存
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 设置弹窗 -->
    <el-dialog
      title="系统设置"
      v-model="showSettingsDialog"
      width="500px"
      :close-on-click-modal="false"
      :fullscreen="isMobile"
    >
      <el-form
        ref="settingsFormRef"
        :model="settingsForm"
        :rules="settingsRules"
        label-width="100px"
      >
        <el-form-item label="学校" prop="school">
          <el-input v-model="settingsForm.school" placeholder="请输入学校" />
        </el-form-item>
        <el-form-item label="专业" prop="subject">
          <el-input v-model="settingsForm.subject" placeholder="请输入专业" />
        </el-form-item>
        <el-form-item label="课程" prop="course">
          <el-input v-model="settingsForm.course" placeholder="请输入课程" />
        </el-form-item>
        <el-form-item label="注册状态" prop="register">
          <el-select v-model="settingsForm.register" placeholder="请选择注册状态" style="width: 100%">
            <el-option label="关闭注册" :value="1" />
            <el-option label="开放注册" :value="2" />
          
          </el-select>
        </el-form-item>
        <el-form-item label="天数" prop="daycount">
          <el-input-number v-model="settingsForm.daycount" :min="1" :max="30" style="width: 100%" />
        </el-form-item>
        <el-form-item label="当前部分" prop="currentpart">
          <el-select v-model="settingsForm.currentpart" placeholder="请选择当前部分" style="width: 100%">
            <el-option 
              v-for="d in settingsForm.daycount" 
              :key="d" 
              :label="`Day ${d}`" 
              :value="`day${d.toString().padStart(2, '0')}`" 
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showSettingsDialog = false">取消</el-button>
          <el-button type="primary" @click="submitSettings" :loading="isSavingSettings">
            保存
          </el-button>
        </span>
      </template>
    </el-dialog>
  </header>
</template>

<script>
import { ArrowDown } from '@element-plus/icons-vue';
import { useStore } from 'vuex';
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import taskApi from '../api/task';
import { ElMessage } from 'element-plus';
import axios from 'axios';

export default {
  components: {
    ArrowDown,
  },
  props: {
    currentDay: {
      type: Number,
      required: true,
    }
  },
  emits: ['showLogin', 'showAddTask'],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();

    const isLogin = computed(() => store.getters.isLogin);
    const userInfo = computed(() => store.getters.userInfo);

    const fullTitle = computed(() => {
      const course = localStorage.getItem('course');
      let title = '-课程任务完成情况统计';

      if (course) {
        title = `${course} ${title}`;
      }
      return title;
    });

    // 添加任务相关状态和方法
    const showAddTaskDialog = ref(false);
    const addFormRef = ref(null);
    const isAdding = ref(false);
    const addForm = ref({
      title: '',
      description: '',
      labels: '',
      part: '',
      orderNum: 1,
      type: '',
    });

    const addRules = {
      title: [
        { required: true, message: '请输入任务标题', trigger: 'blur' },
        { max: 255, message: '标题不能超过255个字符', trigger: 'blur' }
      ],
      description: [
        { required: true, message: '请输入任务描述', trigger: 'blur' }
      ],
      part: [
        { required: true, message: '请输入任务部分', trigger: 'blur' }
      ],
      orderNum: [
        { required: true, message: '请输入任务序号', trigger: 'blur' }
      ],
      type: [
        { required: true, message: '请输入任务类型', trigger: 'blur' }
      ]
    };

    // 添加学生相关状态和方法
    const showAddStudentDialog = ref(false);
    const addStudentFormRef = ref(null);
    const isAddingStudent = ref(false);
    const addStudentForm = ref({
      studentId: '',
      username: '',
    });

    const addStudentRules = {
      studentId: [
        { required: true, message: '请输入学号', trigger: 'blur' },
        { pattern: /^\d{1,20}$/, message: '学号是1-20位数字', trigger: 'blur' }
      ],
      username: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
      ],
    };

    // 设置相关状态和方法
    const showSettingsDialog = ref(false);
    const settingsFormRef = ref(null);
    const isSavingSettings = ref(false);
    const settingsForm = ref({
      type: '',
      school: '',
      subject: '',
      course: '',
      register: 0,
      daycount: 4,
      currentpart: '',
    });

    const settingsRules = {
      type: [
        { required: true, message: '请输入类型', trigger: 'blur' }
      ],
      school: [
        { required: true, message: '请输入学校', trigger: 'blur' }
      ],
      subject: [
        { required: true, message: '请输入专业', trigger: 'blur' }
      ],
      course: [
        { required: true, message: '请输入课程', trigger: 'blur' }
      ],
      register: [
        { required: true, message: '请选择注册状态', trigger: 'change' }
      ],
      daycount: [
        { required: true, message: '请输入天数', trigger: 'blur' }
      ],
      currentpart: [
        { required: true, message: '请选择当前部分', trigger: 'change' }
      ]
    };

    const handleShowAddTask = () => {
      if (addFormRef.value) {
        addFormRef.value.resetFields();
      }
      addForm.value = {
        title: '',
        description: '',
        labels: '',
        part: '',
        orderNum: 1,
        type: '',
      };
      showAddTaskDialog.value = true;
    };

    const handleShowAddStudent = () => {
      if (addStudentFormRef.value) {
        addStudentFormRef.value.resetFields();
      }
      addStudentForm.value = {
        studentId: '',
        username: '',
      };
      showAddStudentDialog.value = true;
    };

    const handleShowSettings = () => {
      // 从localStorage获取当前设置并回显
      settingsForm.value = {
        school: localStorage.getItem('school') || '',
        subject: localStorage.getItem('subject') || '',
        course: localStorage.getItem('course') || '',
        register: parseInt(localStorage.getItem('register')) || 0,
        daycount: parseInt(localStorage.getItem('daycount')) || 4,
        currentpart: localStorage.getItem('currentpart') || '',
      };
      showSettingsDialog.value = true;
    };

    const submitAddTask = async () => {
      if (!addFormRef.value) return;
      
      await addFormRef.value.validate(async (valid) => {
        if (valid) {
          isAdding.value = true;
          try {
            const response = await taskApi.addTask(addForm.value);
            if (response.code === '000000') {
              ElMessage.success('任务添加成功');
              showAddTaskDialog.value = false;
              emit('refresh'); // 触发父组件刷新任务列表
            } else {
              throw new Error(response.msg || '添加失败');
            }
          } catch (error) {
            ElMessage.error('添加任务失败: ' + error.message);
          } finally {
            isAdding.value = false;
          }
        }
      });
    };

    const submitAddStudent = async () => {
      if (!addStudentFormRef.value) return;
      
      await addStudentFormRef.value.validate(async (valid) => {
        if (valid) {
          isAddingStudent.value = true;
          try {
            const response = await axios.post('/api/user/add', {
              studentId: addStudentForm.value.studentId,
              username: addStudentForm.value.username
            });
            
            if (response.data.code === '000000') {
              ElMessage.success('学生添加成功');
              showAddStudentDialog.value = false;
              // 清空表单
              addStudentForm.value = {
                studentId: '',
                username: '',
              };
            } else {
              throw new Error(response.data.msg || '添加失败');
            }
          } catch (error) {
            ElMessage.error('添加学生失败: ' + (error.response?.data?.msg || error.message));
          } finally {
            isAddingStudent.value = false;
          }
        }
      });
    };

    const submitSettings = async () => {
      if (!settingsFormRef.value) return;
      
      await settingsFormRef.value.validate(async (valid) => {
        if (valid) {
          isSavingSettings.value = true;
          try {
            const response = await axios.post('/api/task/settings', {
              course: settingsForm.value.course,
              currentpart: settingsForm.value.currentpart,
              daycount: settingsForm.value.daycount,
              register: settingsForm.value.register,
              school: settingsForm.value.school,
              subject: settingsForm.value.subject,
              type: settingsForm.value.type
            });
            
            if (response.data.code == 200) {
              ElMessage.success('设置保存成功');
              showSettingsDialog.value = false;
              
              // 更新localStorage
              localStorage.setItem('school', settingsForm.value.school);
              localStorage.setItem('subject', settingsForm.value.subject);
              localStorage.setItem('course', settingsForm.value.course);
              localStorage.setItem('register', settingsForm.value.register.toString());
              localStorage.setItem('daycount', settingsForm.value.daycount.toString());
              localStorage.setItem('currentpart', settingsForm.value.currentpart);
              
              // 触发页面刷新
              window.location.reload();
            } else {
              throw new Error(response.data.msg || '保存失败');
            }
          } catch (error) {
            ElMessage.error('保存设置失败: ' + (error.response?.data?.msg || error.message));
          } finally {
            isSavingSettings.value = false;
          }
        }
      });
    };

    const logout = () => {
      store.dispatch('logout');
      localStorage.removeItem('user');
      router.push('/');
    };

    const goToAttendance = () => {
      router.push('/attendance');
    };

    const goToUserList = () => {
      router.push('/user-list');
    };

    const goToTaskList = () => {
      router.push('/');
    };

    const goToSeatMap = () => {
      router.push('/seat-map');
    };

    // 判断是否是移动端
    const isMobile = ref(false);
    const checkIsMobile = () => {
      isMobile.value = window.innerWidth < 768; 
    };

    onMounted(() => {
      checkIsMobile();
      window.addEventListener('resize', checkIsMobile);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkIsMobile);
    });

    return {
      isLogin,
      userInfo,
      logout,
      goToAttendance,
      fullTitle,
      showAddTaskDialog,
      addForm,
      addRules,
      addFormRef,
      isAdding,
      handleShowAddTask,
      submitAddTask,
      showAddStudentDialog,
      addStudentForm,
      addStudentRules,
      addStudentFormRef,
      isAddingStudent,
      handleShowAddStudent,
      submitAddStudent,
      isMobile,
      goToUserList,
      goToTaskList,
      showSettingsDialog,
      settingsForm,
      settingsRules,
      settingsFormRef,
      isSavingSettings,
      handleShowSettings,
      submitSettings,
      goToSeatMap,
    };
  },
};
</script>

<style scoped>
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #eee;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-actions span {
  margin-right: 10px;
}

.attendance-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}

.user-list-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}

.task-list-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--el-text-color-primary);
}

.el-dropdown-link:hover {
  color: var(--el-color-primary);
}

@media (max-width: 768px) {
  .header-bar {
    padding: 8px 12px;
    flex-direction: column; /* On mobile, stack items vertically */
    align-items: flex-start; /* Align items to the start */
  }

  .header-bar h2 {
    font-size: 1.1em;
    margin-bottom: 10px; /* Add some space below the title */
  }

  .header-actions {
    gap: 8px;
    width: 100%; /* Make actions take full width */
    justify-content: flex-end; /* Align buttons to the right */
  }

  .attendance-btn {
    padding: 6px 12px;
  }

  /* Dialog specific styles for mobile */
  .el-dialog {
    width: 95% !important;
  }

  .el-dialog__body .el-form {
    padding: 0 10px 10px;
  }

  .el-dialog__footer {
    padding: 10px;
  }

  .el-form-item {
    margin-bottom: 15px;
  }
}
</style> 